import React, { useState, useEffect } from "react";
import Axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";
import CanvasJSReact from "../../../../../../assets/canvasjs.react";

// Components
import { Container, Title } from "./styles";
import { Row, Col, Spin } from "antd";
// Services

import { getResultSumarySell } from "../../../../../../services/saleScenarioService";
import { getTwoDecimalDigits } from "../../../../../../services/helpersMethodsService";

function SaleSummaryChart({ dataResult }) {
  // Variables
  const { CanvasJSChart } = CanvasJSReact;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);

  const toggleDataSeries = (e) => {
    if (typeof e.dataSeries.visible === "undefined" || e.dataSeries.visible) {
      e.dataSeries.visible = false;
    } else {
      e.dataSeries.visible = true;
    }
    e.chart.render();
  };
  const chartOptions = {
    animationEnabled: true,
    zoomEnabled: true,
    dataPointWidth: 22,
    height: 290,
    axisX: {
      title: "",
    },
    toolTip: {
      fontFamily: "Asap",
      shared: true,
    },
    axisY: {
      includeZero: true,
      prefix: "R$ ",
      valueFormatString: "#0",
    },
    axisY2: {
      suffix: "",
    },
    legend: {
      cursor: "pointer",
      itemclick: toggleDataSeries,
    },
    data: data,
  };

  const {
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);

  useEffect(() => {
    let signal = Axios.CancelToken.source();
    let mount = true;
    const { saleScenarioId } = dataResult;

    async function fetch() {
      let dData = [];
      let dataLabel;
      try {
        const {
          data: { results },
        } = await getResultSumarySell({ groupId, farmId, saleScenarioId });

        dataLabel =
          moment(results.createdAt, "YYYY-MM-DD")
            .format("DD/MM/YYYY")
            .toString() + " - Hoje";

        const estimatedBilling = {
          label: dataLabel,
          y: getTwoDecimalDigits(results.estimatedBilling || 0),
        };

        const totalBilling = {
          label: dataLabel,
          y: getTwoDecimalDigits(results.totalBilling || 0),
        };

        const estimatedMargin = {
          label: dataLabel,
          y: getTwoDecimalDigits(results.estimatedMargin || 0),
        };

        const totalMargin = {
          label: dataLabel,
          y: getTwoDecimalDigits(results.totalMargin || 0),
        };

        const amountAnimalsEstimated = {
          label: dataLabel,
          y: results.amountAnimalsEstimated || 0,
        };

        const amountAnimalsSold = {
          label: dataLabel,
          y: results.amountAnimalsSold || 0,
        };

        dData = [
          ...dData,
          {
            type: "column",
            name: "Faturamento planejado",
            color: "#4A85AE",
            dataPoints: [estimatedBilling],
          },
          {
            type: "column",
            name: "Faturamento real",
            color: "#FE8D2A",
            dataPoints: [totalBilling],
          },
          {
            type: "column",
            name: "Lucro planejado",
            color: "#031926",
            dataPoints: [estimatedMargin],
          },
          {
            type: "column",
            name: "Lucro real",
            color: "#A5B452",
            dataPoints: [totalMargin],
          },
          {
            type: "column",
            axisYType: "secondary",
            name: "Qtd. estimada de venda",
            color: "#FF006E",
            dataPoints: [amountAnimalsEstimated],
          },
          {
            type: "column",
            axisYType: "secondary",
            name: "Qtd. real de venda",
            color: "#7600FF",
            dataPoints: [amountAnimalsSold],
          },
        ];
      } catch (error) {}
      if (mount) {
        setData(dData);
        setIsLoading(false);
      }
    }
    fetch();
    return () => {
      mount = false;
      signal.cancel();
    };
  }, [groupId, farmId, dataResult]);

  return (
    <Container>
      <Row type="flex">
        <Col span={24}>
          <Title>Resumo do Cenário de Venda</Title>
        </Col>
      </Row>
      <Row type="flex" style={{ margintTop: 15 }}>
        <Col span={24}>
          <Spin spinning={isLoading}>
            <CanvasJSChart options={chartOptions} />
          </Spin>
        </Col>
      </Row>
    </Container>
  );
}

export default SaleSummaryChart;
